<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="row m-0 g-0">
    <div class="col-md-3 p-0">
      <app-folders></app-folders>
    </div>

    <div class="col-md-9 container" style="border-top-left-radius: 15px; border-top-right-radius: 15px; overflow: hidden; margin-top: 0 !important; margin-left: -7px;">
      <div class="card" style="height: 1000px;">
        <div class="card-body">
          <div class="d-flex justify-content-start" style="margin-top: 0 !important;">
            <button type="button" class="btn custom-button" style="margin-bottom:10px ;"   (click)="goBack()">Back</button>
          </div>
         
<!-- new -->
<div class="new-card"
      style="border: 2px solid #4A148C; border-radius: 12px; padding: 10px 20px;background-color: #ffffff; box-shadow: 0 4px 12px rgba(103, 58, 183, 0.1);margin-bottom: -15px; font-family: 'Segoe UI', sans-serif; ">
  <div class="card-content">
    <div class="row d-flex align-items-center justify-content-between flex-wrap" style="gap: 12px; font-size: 15px; color: #333;">
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Code:</strong> {{ studyCode }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Name:</strong> {{ studyName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Subject Name:</strong> {{ subjectName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Site Location:</strong> {{ siteLocation }}
      </div>
    </div>
  </div>
</div>

            <div *ngIf="formName === 'adverse-event-report'" class="card mt-4">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="m-0">Adverse Event Log</h5>
                  <!--<button type="button" class="btn custom-button">Create Field</button>-->
                </div>
          
       <!-- Small Modal (Right-side) -->
        <div class="options-modal" *ngIf="isOptionsModalOpen" (click)="$event.stopPropagation()" style="margin-top: 47px; margin-right: 40px;">
  <div class="modal-buttons">
    <button (click)="openModal()">Query</button>
    <button (click)="editStudy()">Edit</button>
    <button (click)="openReviewModal()">Review</button>
  </div>
  </div>
<div class="modal-overlay" *ngIf="isReasonModalOpen">
  <div class="modal-content">
    <button class="close-btn" (click)="cancelEditReason()">×</button>
    <h4>Please provide a reason for editing:</h4>
    <textarea class="form-control" [(ngModel)]="editReason" rows="4" placeholder="Enter reason here..."></textarea>
    <div class="modal-footer">
      <button class="btn custom-button" (click)="confirmEditReason()">Confirm</button>
      <button class="btn custom-button" (click)="cancelEditReason()">Cancel</button>
    </div>
  </div>
</div>
  <!-- Review Modal -->
<div class="modal-overlay1" *ngIf="showReviewModal" (click)="closeReviewModal()">
   <!-- Close Button -->
   <span class="close-button1" (click)="closeReviewModal()">×</span>
  <div class="modal-content1" (click)="$event.stopPropagation()">
   
     <div class="checkbox-group">
      <div class="form-check" style="margin-top: 20px;">
        <input type="checkbox" id="reviewedByDataMonitor" name="reviewedByDataMonitor" [(ngModel)]="reviewOptions.dataMonitor">
        <label for="reviewedByDataMonitor">Reviewed by Data Monitor</label>
      </div>
    </div>
    <div class="checkbox-group">
      <div class="form-check">
        <input type="checkbox" id="reviewedByMonitor" name="reviewedByMonitor" [(ngModel)]="reviewOptions.monitor" [disabled]="!hasAdverseEventData || !reviewOptions.dataMonitor || userDesignation !== 'monitor'"
      (change)="onReviewCheckboxChange()">
        <label for="reviewedByMonitor">Reviewed by Monitor</label>
      </div>
    </div>
    <div class="checkbox-group">
      <div class="form-check">
        <input type="checkbox" id="reviewedByPI" name="reviewedByPI" [(ngModel)]="reviewOptions.pi" [disabled]="!hasAdverseEventData || !reviewOptions.dataMonitor || !reviewOptions.monitor || userDesignation !== 'pi'">
        <label for="reviewedByPI">Reviewed by PI</label>
      </div>
    </div>
  </div>
</div>

        
        <div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content">
     <button class="close-btn" (click)="closeModal()">&times;</button>
     
    <!-- Tab Bar -->
    <div class="tab-bar">
      <div 
        class="tab" 
        *ngFor="let tab of tabs; let idx = index" 
        [class.active]="selectedTab === idx" 
        (click)="selectTab(idx)">
        {{ tab.title }}
        <span class="close-tab" *ngIf="tabs.length > 1" (click)="closeTab(idx, $event)">×</span>
      </div>
      
      <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
       <div *ngIf="tabs[selectedTab].type === 'query'" class="add-btn-wrapper">
          <button class="add-btn" (click)="addQuery(i)">+</button>
          <span class="add-query-tooltip">Add Query</span>
        </div> 
    </div>
   

    <!-- Modal Body -->
    <div class="modal-body">
      <ng-container [ngSwitch]="tabs[selectedTab].type">

        <!-- Query Tab -->
        <div *ngSwitchCase="'query'">
          <div *ngFor="let query of queries; let i = index" class="query-box">
              <!-- Dropdown Field -->
          <select class="form-select mb-2" [(ngModel)]="query.selectedField" [disabled]="query.isClosed">
            <option>Select Column</option>
            <option>Log Line</option>
            <option>Adverse Event Term</option>
            <option>Onset Date</option>
            <option>End Date</option>
            <option>Medication Taken (Y/N)</option>
            <option>Ongoing</option>
            <option>Severity</option>
            <option>Relationship to Study Drug</option>
            <option>Action</option>
            <option>Outcome</option>
            <option>Dropped due to this AE?</option>
            <option>Reported as SAE?</option>
          </select>
          <br>
            <div class="input-checkbox-container">
            
              <input
                type="text"
                class="form-control"
                [value]="''"
                (input)="query.text = $event.target.value"
                [readonly]="query.isClosed"
                [ngClass]="{ 'query-closed': query.isClosed }"
                placeholder="Enter your query"
              />



              
             
            </div>
            
            <!-- Audit Trail -->
            <div class="audit-trail">
              <h4>Audit Trail</h4>
              <div class="audit-entry" *ngFor="let entry of query.auditTrail">
                <strong>{{ entry.user }}</strong>- {{ entry.timestamp | date: 'dd-MMM-yyyy h:mm a' }}

                <p>{{ entry.message }}</p>
              </div>
            </div>
            <div class="modal-footer">
      <button class="btn custom-button" (click)="confirmCloseQuery(i)">Close Query</button>
      <button class="btn custom-button ms-2" (click)="confirmSubmitQuery(i)">Submit</button>
      
    </div>
          </div>
        </div>

        <!-- Field History Tab -->
        <div *ngSwitchCase="'fieldHistory'">
          <div *ngIf="fieldHistoryData?.length > 0; else noData">
            <div *ngFor="let entry of fieldHistoryData" class="history-box">
              <div class="history-header">
                <strong>{{ entry.updated_by }}</strong> - {{ entry.updated_at | date: 'medium' }}
              </div>
              <div class="history-value">
                {{ entry.sub_data }}
              </div>
              <!-- ✅ Show edit reason if available -->
      <div class="edit-reason" *ngIf="entry.edit_reason">
        <em>Reason for change: {{ entry.edit_reason }}</em>
      </div>
       <div class="log-label" *ngIf="entry.field_name">
    <small>Field: {{ entry.field_name }}</small>
  </div>
            </div>
          </div>
          <ng-template #noData>
            <p>No history available for this field.</p>
          </ng-template>
        </div>

      </ng-container>
    </div>


    
  </div> 
</div>

                <!-- Table for Adverse Event Log -->
    <div class="card-body scrollable-container">
      <div class="label-wrapper d-flex align-items-center justify-content-between">
      <button type="button" class="btn custom-button" (click)="addLogLine()">Add Log Line</button>
      <div class="menu-icon" (click)="openOptionsModal($event, $event.target)">⋮</div>
      </div>
      <form (ngSubmit)="submitForm()">
          <div class="table-wrapper">
              <table class="table table-bordered">
                  <thead>
                      <tr>
                          <th class="wide-input">Log Line</th>
                          <th style="width: 100px;">Adverse Event Term</th>
                          <th>Onset Date</th>
                          <th>End Date</th>
                          <th>Medication Taken (Y/N)</th>
                          <th>Ongoing</th>
                          <th style="width: 80px;">Severity</th>
                          <th>Relationship to Study Drug</th>
                          <th style="width: 150px;">Action</th>
                          <th>Outcome</th>
                          <th>Dropped due to this AE?</th>
                          <th>Reported as SAE?</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let log of formData.adverseEventLogs; let i = index">
                          <td><input type="text" class="form-control wide-input" [(ngModel)]="log.logLine" name="logLine{{i}}" [disabled]="isAdverseLogDisabled"></td>
                          <td><input type="text" class="form-control" style="width: 100px;" [(ngModel)]="log.eventTerm" name="eventTerm{{i}}" [disabled]="isAdverseLogDisabled"></td>
                          <td><input type="date" class="form-control" [(ngModel)]="log.onsetDate" name="onsetDate{{i}}" [min]="screeningMinDate"
                            [max]="todayDate" (change)="updateEndDateRange(log)" (blur)="validateDate(log.onsetDate, i)" [disabled]="isAdverseLogDisabled"></td>
                          <td><input type="date" class="form-control" [(ngModel)]="log.endDate" name="endDate{{i}}" [min]="log.onsetDate" [disabled]="isAdverseLogDisabled"
                            [max]="todayDate" [disabled]="isAdverseLogDisabled"></td>
                          <td>
                              <select class="form-control" [(ngModel)]="log.medicationTaken" name="medicationTaken{{i}}" [disabled]="isAdverseLogDisabled">
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                              </select>
                          </td>
                          <td>
                              <select class="form-control" [(ngModel)]="log.ongoing" name="ongoing{{i}}" [disabled]="isAdverseLogDisabled">
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                              </select>
                          </td>
                          <td>
                              <select class="form-control" style="width: 80px;" [(ngModel)]="log.severity" name="severity{{i}}" [disabled]="isAdverseLogDisabled">
                                  <option value="1">Mild</option>
                                  <option value="2">Moderate</option>
                                  <option value="3">Severe</option>
                              </select>
                          </td>
                          <td>
                              <select class="form-control" [(ngModel)]="log.relationship" name="relationship{{i}}" [disabled]="isAdverseLogDisabled">
                                  <option value="1">Unrelated</option>
                                  <option value="2">Unlikely</option>
                                  <option value="3">Possible</option>
                                  <option value="4">Probable</option>
                                  <option value="5">Definite</option>
                              </select>
                          </td>
                          <td>
                              <select class="form-control" [(ngModel)]="log.action" style="width: 150px;" name="action{{i}}" [disabled]="isAdverseLogDisabled">
                                  <option value="1">Study drug Withdrawn</option>
                                  <option value="2">Study drug Dose Reduced</option>
                                  <option value="3">Study drug Dose Increased</option>
                                  <option value="4">Study drug Dose Not Changed</option>
                                  <option value="5">Unknown</option>
                                  <option value="6">Not Applicable</option>
                              </select>
                          </td>
                          <td>
                              <select class="form-control" [(ngModel)]="log.outcome" name="outcome{{i}}" [disabled]="isAdverseLogDisabled">
                                  <option value="1">Resolved</option>
                                  <option value="2">Resolving</option>
                                  <option value="3">Not Resolved</option>
                                  <option value="4">Resolved with sequelae</option>
                                  <option value="5">Fatal</option>
                                  <option value="6">Unknown</option>
                              </select>
                          </td>
                          <td>
                              <select class="form-control" [(ngModel)]="log.droppedAE" name="droppedAE{{i}}" [disabled]="isAdverseLogDisabled">
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                              </select>
                          </td>
                          <td>
                              <select class="form-control" [(ngModel)]="log.reportedSAE" name="reportedSAE{{i}}" [disabled]="isAdverseLogDisabled">
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                              </select>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
           <div class="text-end">
             <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
            <button type="submit" class="btn custom-button">Submit</button>
          </div>

      </form>
  </div>
</div>

                </div> <!-- Closing for card-body -->
              </div> <!-- Closing for card -->
            </div> <!-- Closing for col-md-9 -->
         <!-- Closing for container-fluid -->
